import dayjs from "dayjs";
import { FC } from "react";
import { getWorkspaceSlotTime } from "utils/utils";
import clockIcon from "../../../assets/images/dashboard-card-clock-icon.svg";
import locationIcon from "../../../assets/images/dashboard-card-location-icon.svg";

interface ActiveMemberLineupViewProps {
  event: any;
  onClick: () => void;
}

const ActiveMemberLineupView: FC<ActiveMemberLineupViewProps> = ({
  event,
  onClick,
}) => {
  return (
    <div
      className={`dashboard-screen-coming-up-events-container-item ${event?.is_cancelled ? "cancelled-overlay" : ""}`}
      onClick={onClick}
    >
      <div
        className="image-container"
        style={{ backgroundImage: `url(${event?.slot_image})` }}
      >
        <div
          className="dashboard-screen-spots-container"
          style={{ justifyContent: "space-between" }}
        >
          <div
            className="content"
            style={{ marginLeft: "6px", marginTop: "6px" }}
          >
            <span className="primary">
              {dayjs(event?.slot_date).format("DD")}
            </span>
            <span className="secondary">
              {dayjs(event?.slot_date).format("MMM")}
            </span>
          </div>
          <div className="city-container">{event?.slot_city}</div>
        </div>
      </div>
      <div className="title-container ">
        <span className="title-reservations">{event?.slot_title}</span>
      </div>

      <div className="divider-reservation"></div>
      <div className="footer-container">
        <div className="item-container">
          <img src={clockIcon} alt="clock-icon" />{" "}
          {getWorkspaceSlotTime(event?.slot_start_time)}
        </div>
        <div className="item-container">
          <img src={locationIcon} alt="location-icon" /> {event?.slot_location}
        </div>
      </div>
    </div>
  );
};

export default ActiveMemberLineupView;
